import React from 'react';
import { Translate } from 'react-redux-i18n';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import chevronDroite from '../../../../img/icones/chevron_droite.svg';
import secours from '../../../../img/home/secours.svg';
import { EMERGENCY_INFO_FORM } from '../../../../routes';
import { UserDTO } from '../../../../network/api/types/compte/UserDTO';

type Props = RouteComponentProps & {
  myUserDetails: UserDTO,
};

function EmergencyInformationBox(props: Props): React.ReactElement {
  return (
    <div className="account-box emergency-info-box">
      <div className="box-img">
        <div className="container-img">
          <img
            className="profile-pic"
            src={secours}
            alt="emergency"
          />
        </div>
        <div className="responsive-title">
          <div className="box-line column">
            <h4>
              <div className="title-background primary" />
              <Translate value="HOME.EMERGENCY_INFORMATION" />
            </h4>
            <div className="subtitle">
              <Translate value="HOME.RECOVER_ACCOUNT" />
            </div>
          </div>
        </div>
      </div>
      <div className="info-column">
        <div className="box-line column title">
          <h4>
            <div className="title-background primary" />
            <Translate value="HOME.EMERGENCY_INFORMATION" />
          </h4>
          <div className="subtitle">
            <Translate value="HOME.RECOVER_ACCOUNT" />
          </div>
        </div>
        <div className="box-line">
          <button
            type="button"
            className="info-row"
            onClick={() => props.history.push(EMERGENCY_INFO_FORM)}
          >
            <div className="chevron-helper">
              <h5 className="button-title">
                <Translate value="HOME.RECOVERY_MAIL" />
              </h5>
              <div className="button-subtitle">
                { props.myUserDetails?.email || <Translate value="PLACEHOLDER.NOMAIL" /> }
              </div>
            </div>
            <img
              className="chevron"
              src={chevronDroite}
              alt="chevron"
            />
          </button>
        </div>
        <div className="box-line no-border">
          <button
            type="button"
            className="info-row"
            onClick={() => props.history.push(EMERGENCY_INFO_FORM)}
          >
            <div className="chevron-helper">
              <h5 className="button-title">
                <Translate value="HOME.EMERGENCY_MAIL" />
              </h5>
              <div className="button-subtitle">
                { props.myUserDetails?.backupEmail || <Translate value="PLACEHOLDER.NOMAIL" /> }
              </div>
            </div>
            <img
              className="chevron"
              src={chevronDroite}
              alt="chevron"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default withRouter(EmergencyInformationBox);
